import LdsTabPanel from "../LdsTabs/LdsTabPanel";
import LdsTabs from "../LdsTabs";
import { useState } from "react";
import Tab1Scan from "../../assets/module-1/1-3-5-15to20.svg";
import Tab2Scan from "../../assets/module-1/1-3-5-30to40.svg";
import Tab3Scan from "../../assets/module-1/1-3-5-50to60.svg";
import Tab4Scan from "../../assets/module-1/1-3-5-80to90.svg";
import LdsImage from "../LdsImage";

export default function TestTabs() {
  const [currentTab, setCurrentTab] = useState(1);
  return (
    <div className="">
      <LdsTabs
        id="tabGroup1"
        activeTab={currentTab}
        onChange={(newIndex) => setCurrentTab(newIndex)}
        tabclassName="underlined"
        tabLabels={[
          { tabId: 1, label: "15-20 Minutes" },
          { tabId: 2, label: "30-40 Minutes" },
          { tabId: 3, label: "50-60 Minutes" },
          { tabId: 4, label: "80-90 Minutes" },
        ]}
      >
        <LdsTabPanel tabId={1} activeTab={currentTab}>
          <LdsImage
            src={Tab1Scan}
            alt="Comparison of brain scans and time-activity curves for a healthy volunteer (left) and a patient with Alzheimer's disease (right) after Amyvid injection. Graphs show standardized uptake values for regions including the precuneus, cortical average, cerebellum gray, and centrum over time, with higher uptake in the Alzheimer's patient."
            style={{ maxWidth: "100%" }}
            className=""
          />
        </LdsTabPanel>
        <LdsTabPanel tabId={2} activeTab={currentTab}>
          <LdsImage
            src={Tab2Scan}
            alt="Comparison of brain scans and time-activity curves between a healthy volunteer (left) and a patient with Alzheimer's disease (right) at 30-40 minutes post-Amyvid injection. Graphs show standardized uptake values for regions including the precuneus, cortical average, cerebellum gray, and centrum, with higher uptake in the Alzheimer's patient."
            style={{ maxWidth: "100%" }}
            className=""
          />
        </LdsTabPanel>
        <LdsTabPanel tabId={3} activeTab={currentTab}>
          <LdsImage
            src={Tab3Scan}
            alt="Comparison of brain scans and time-activity curves between a healthy volunteer (left) and a patient with Alzheimer's disease (right) at 50-60 minutes post-Amyvid injection. Graphs show standardized uptake values for regions such as the precuneus, cortical average, cerebellum gray, and centrum, with higher uptake seen in the Alzheimer's patient."
            style={{ maxWidth: "100%" }}
            className=""
          />
        </LdsTabPanel>
        <LdsTabPanel tabId={4} activeTab={currentTab}>
          <LdsImage
            src={Tab4Scan}
            alt="Comparison of brain scans and time-activity curves between a healthy volunteer (left) and a patient with Alzheimer's disease (right) at 80-90 minutes post-Amyvid injection. The graphs show standardized uptake values for the precuneus, cortical average, cerebellum gray, and centrum, with higher uptake in the Alzheimer's patient."
            style={{ maxWidth: "100%" }}
            className=""
          />
        </LdsTabPanel>
      </LdsTabs>
    </div>
  );
}
